/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import Vue from 'vue'

import {
    LayoutPlugin,
    ModalPlugin,
    FormPlugin, FormFilePlugin, FormCheckboxPlugin, FormSelectPlugin, FormInputPlugin, FormGroupPlugin, InputGroupPlugin, FormRadioPlugin,
    FormTextareaPlugin,
    TabsPlugin,
    LinkPlugin,
    ButtonPlugin, ButtonGroupPlugin,
    ListGroupPlugin,
    CardPlugin, CollapsePlugin,
    DropdownPlugin,
    AlertPlugin,
    PopoverPlugin,
    TooltipPlugin
} from 'bootstrap-vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faSearch,
    faTimes,
    faSync,
    faArrowsAlt,
    faMinus,
    faCircle,
    faCopy,
    faSort, faSortUp, faSortDown,
    faPen, faTrash, faPlus, faSave
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VCalendar from 'v-calendar/lib/components/calendar.umd'

require('./bootstrap');
window.Vue = Vue

library.add(faSearch, faTimes, faSync, faArrowsAlt, faPlus, faMinus, faCircle, faCopy, faPen, faTrash, faSave, faSort, faSortUp, faSortDown)

Vue.use(LayoutPlugin)
Vue.use(ModalPlugin)
Vue.use(FormPlugin)
Vue.use(FormFilePlugin)
Vue.use(FormCheckboxPlugin)
Vue.use(FormSelectPlugin)
Vue.use(TabsPlugin)
Vue.use(FormInputPlugin)
Vue.use(ListGroupPlugin)
Vue.use(FormGroupPlugin)
Vue.use(LinkPlugin)
Vue.use(ButtonPlugin)
Vue.use(ButtonGroupPlugin)
Vue.use(InputGroupPlugin)
Vue.use(CardPlugin)
Vue.use(DropdownPlugin)
Vue.use(AlertPlugin)
Vue.use(FormTextareaPlugin)
Vue.use(CollapsePlugin)
Vue.use(PopoverPlugin)
Vue.use(FormRadioPlugin)
Vue.use(TooltipPlugin)

Vue.component('fa-icon', FontAwesomeIcon)
Vue.component('form-row', require('./components/forms/row.vue').default);
Vue.component('v-calendar', VCalendar)
Vue.component('edit-classes-form', require('./components/EditClassesForm.vue').default);
Vue.component('assign-device-form', require('./components/AssignDeviceForm').default);
Vue.component('dashboards', require('./components/Dashboards.vue').default);
Vue.component('widgets-form-create', require('./components/widgets/FormCreateWidget.vue').default);
Vue.component('widgets-form-edit', require('./components/widgets/FormEditWidget.vue').default);
Vue.component('analyze-traffic-data', require('./components/AnalyzeTrafficData').default)
Vue.component('invite-url-generator', require('./components/invites/InviteUrlGenerator').default);

Vue.component('assign-location-form', require('./components/AssignLocationForm').default);

Vue.component('v-chart', require('./components/Chart.vue').default);
Vue.component('data-loader', require('./components/DataLoader.vue').default)

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.mixin({
    methods: {
        fetchJson(url) {
            return fetch(url, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            })
        }
    }
})

const app = new Vue({
    el: '#app'
});
